import { IOSSwitch } from '@/components/IOSSwitch';
import { FormHelperText, SwitchProps } from '@mui/material';
import { Field, FieldProps } from 'formik';

export const CustomIOSSwitch = (props: SwitchProps) => {
  return (
    <Field name={props.name}>
      {({ field, form: { touched, errors } }: FieldProps) => (
        <>
          <IOSSwitch
            {...props}
            {...field}
            checked={field.value === 'false' ? !field.value : !!field.value}
          />
          {touched[field.name] && Boolean(errors[field.name]) && (
            <FormHelperText error>{errors[field.name]}</FormHelperText>
          )}
        </>
      )}
    </Field>
  );
};
